import { IOffer } from '../repositories/search-offers/v2/types/offer';

export const getOfferServices = (offer: IOffer) => {
  const { isTop3, isPremium, isColorized, isPaid, isAuction } = offer;

  return { isTop3, isPremium, isColorized, isPaid, isAuction };
};
